<template>
	<b-card>
		<template #header>
        	<span style="font-size: 20px; font-weight: bold">Параметры</span>
			<b-button v-if="disabled" @click="editBtn()" variant="primary" style="font-size: 15px; padding: 5px 8px" class="float-right fa fa-edit"/>
			<!--<b-button v-if="disabled" @click="createBtn()" variant="success" style="font-size: 15px" class="float-right fa fa-plus mr-3"/>-->
			<span v-else>
				<b-button @click="save()" variant="success" style="font-size: 15px; padding: 5px 8px" class="float-right fa fa-check ml-2"/>
				<b-button @click="cancel()" variant="danger" style="font-size: 15px; padding: 5px 8px" class="float-right fa fa-close"/>
			</span>
      	</template>
		<b-row class="mt-2">
			<b-col>
				<b-input-group prepend="Под.налог жен:">
      				<b-form-input v-model="form.womanIncomeTax" :disabled="disabled" type="number" placeholder="Под.налог жен"/>
    			</b-input-group>
			</b-col>
			<b-col>
				<b-input-group prepend="Под.налог муж:">
      				<b-form-input v-model="form.husbandIncomeTax" :disabled="disabled" type="number" placeholder="Под.налог муж"/>
    			</b-input-group>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col>
				<div v-for="(per, index) in percentages" :key="`per-${index}`">
					<b-input-group prepend="Их процент:" append="%">
						<b-form-input v-model="per.paramFrom" :disabled="disabled" type="number" placeholder="От"/>
						<b-form-input v-model="per.paramTo" :disabled="disabled" type="number" placeholder="До"/>
						<b-form-input v-model="per.paramPercentage" :disabled="disabled" type="number" placeholder="процент"/>
					</b-input-group>
					<b-badge v-if="(percentages.length===(index+1)) && !disabled" @click="percentages.push({})" class="float-right" variant="primary"><i class="fa fa-plus"/></b-badge>
					<b-badge v-if="percentages.length!==1 && !disabled" @click="percentages.splice(index, 1)" variant="danger" class="float-right"><i class="fa fa-minus"/></b-badge>
				</div>
			</b-col>
			<b-col cols="3">
				<b-input-group prepend="Пенс:" append="%">
      				<b-form-input v-model="form.percentagePension" :disabled="disabled" type="number" placeholder="Пенс"/>
    			</b-input-group>
			</b-col>
			<b-col cols="3">
				<b-input-group prepend="ИНПС:" append="%">
      				<b-form-input v-model="form.inps" :disabled="disabled" type="number" placeholder="ИНПС"/>
    			</b-input-group>
			</b-col>
		</b-row>
		<hr/>
		<div class="text-center mt-3">
			<h5><b>Главный бухгалтер</b></h5>
		</div>
		<b-row class="mt-3">
			<b-col>
				<b-input-group prepend="Фамилия:">
      				<b-form-input v-model="form.surnameAcc" :disabled="disabled" type="text" placeholder="Фамилия"/>
    			</b-input-group>
			</b-col>
			<b-col>
				<b-input-group prepend="Имя:">
      				<b-form-input v-model="form.nameAcc" :disabled="disabled" type="text" placeholder="Имя"/>
    			</b-input-group>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col>
				<b-input-group prepend="Отчество:">
      				<b-form-input v-model="form.midNameAcc" :disabled="disabled" type="text" placeholder="Отчество"/>
    			</b-input-group>
			</b-col>
			<b-col>
				<b-input-group prepend="ИНН:">
      				<b-form-input v-model="form.innAcc" :disabled="disabled" type="number" placeholder="ИНН"/>
    			</b-input-group>
			</b-col>
		</b-row>
		<hr/>
		<div class="text-center mt-3">
			<h5><b>Руководитель</b></h5>
		</div>
		<b-row class="mt-3">
			<b-col>
				<b-input-group prepend="Фамилия:">
      				<b-form-input v-model="form.surnameDir" :disabled="disabled" type="text" placeholder="Фамилия"/>
    			</b-input-group>
			</b-col>
			<b-col>
				<b-input-group prepend="Имя:">
      				<b-form-input v-model="form.nameDir" :disabled="disabled" type="text" placeholder="Имя"/>
    			</b-input-group>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col>
				<b-input-group prepend="Отчество:">
      				<b-form-input v-model="form.midNameDir" :disabled="disabled" type="text" placeholder="Отчество"/>
    			</b-input-group>
			</b-col>
			<b-col>
				<b-input-group prepend="ИНН:">
      				<b-form-input v-model="form.innDir" :disabled="disabled" type="number" placeholder="ИНН"/>
    			</b-input-group>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import SkyShopService from './skyshop.service.js'

export default {
	data() {
		return {
			disabled: true,
			form: {},
			copy: null,
			create: false,
			percentages: [{}]
		}
	},
	methods: {
		get() {
			SkyShopService.getSetting().then(res => {
				this.form = res.data
				this.percentages = (res.data.paramList && res.data.paramList.length>0) ? res.data.paramList : [{}]
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		createBtn() {
			this.create = true
			this.copy = {}
			this.copy = Object.assign({}, this.form)
			this.disabled = false
		},
		editBtn() {
			this.create = false
			this.copy = {}
			this.copy = Object.assign({}, this.form)
			this.disabled = false
		},
		cancel() {
			this.form = Object.assign({}, this.copy)
			this.copy = null
			this.disabled = true
		},
		save() {
			// if (this.create) {
				let data = {
					inactiveId: this.form.id,
					womanIncomeTax: this.form.womanIncomeTax,
					husbandIncomeTax: this.form.husbandIncomeTax,
					paramList: this.percentages,
					percentagePension: this.form.percentagePension,
					inps: this.form.inps,
					surnameAcc: this.form.surnameAcc,
					nameAcc: this.form.nameAcc,
					midNameAcc: this.form.midNameAcc,
					innAcc: this.form.innAcc,
					surnameDir: this.form.surnameDir,
					nameDir: this.form.nameDir,
					midNameDir: this.form.midNameDir,
					innDir: this.form.innDir
				}
				SkyShopService.saveSetting(data).then(res => {
					this.copy = null
					this.disabled = true
					this.$vs.notify({
						title: 'Успешно сохранено !',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
				}).catch(e => {
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			// } else {
			// 	SkyShopService.saveSetting(this.form).then(res => {
			// 		this.copy = null
			// 		this.disabled = true
			// 		this.$vs.notify({
			// 			title: 'Успешно сохранено !',
			// 			color: 'success',
			// 			icon: 'close',
			// 			position: 'top-right'
			// 		});
			// 	}).catch(e => {
			// 		this.$vs.notify({
			// 			title: e.message,
			// 			color: 'danger',
			// 			icon: 'close',
			// 			position: 'top-right'
			// 		});
			// 	})
			// }
		}
	},
	created() {
		this.get();
	}
}
</script>

<style scoped>
</style>
